import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IDocData, ResearchStatusType, IResearchResponce } from 'interfaces';

export interface ResearchState {
  reportDocumentData: IDocData | null;
  reportDocumentRawData: IResearchResponce | null;
  reportDocumentSigningData: any | null;
  reportDocumentID: string | null;
  reportDocumentRoomID: string;
  reportDocumentName: string;
  isResearchModalOpen: boolean;
  isLoading: boolean;
  response: any | null;
  uploadedFileName: string;
  reportStatus: ResearchStatusType | null;
  reportSegment: 'info' | 'changes' | 'actions';
  isReportDocumentHasNoToken: boolean;
}

const initialState: ResearchState = {
  reportDocumentData: null,
  reportDocumentRawData: null,
  reportDocumentSigningData: null,
  reportDocumentID: null,
  reportDocumentRoomID: '',
  reportDocumentName: '',
  isResearchModalOpen: false,
  isLoading: false,
  response: null,
  uploadedFileName: '',
  reportStatus: null,
  reportSegment: 'info',
  isReportDocumentHasNoToken: false,
};

const researchSlice = createSlice({
  name: 'research',
  initialState,
  reducers: {
    setIsResearchModalOpen(state, action: PayloadAction<boolean>) {
      state.isResearchModalOpen = action.payload;
    },
    setReportDocumentData(state, action: PayloadAction<IDocData>) {
      state.reportDocumentData = action.payload;
    },
    setReportDocumentRawData(state, action: PayloadAction<IResearchResponce>) {
      state.reportDocumentRawData = action.payload;
    },
    setReportDocumentSigningData(state, action: PayloadAction<any>) {
      state.reportDocumentSigningData = action.payload;
    },
    setReportDocumentID(state, action: PayloadAction<string>) {
      state.reportDocumentID = action.payload;
    },
    setReportDocumentRoomID(state, action: PayloadAction<string>) {
      state.reportDocumentRoomID = action.payload;
    },
    setReportDocumentName(state, action: PayloadAction<string>) {
      state.reportDocumentName = action.payload;
    },
    setIsReportDocumentHasNoToken(state, action: PayloadAction<boolean>) {
      state.isReportDocumentHasNoToken = action.payload;
    },
    setReportSegment(state, action: PayloadAction<'info' | 'changes' | 'actions'>) {
      state.reportSegment = action.payload;
    },
  },
});

export const {

  setIsResearchModalOpen,
  setReportDocumentData,
  setReportDocumentRawData,
  setReportDocumentSigningData,
  setReportDocumentID,
  setReportDocumentRoomID,
  setIsReportDocumentHasNoToken,
  setReportSegment,
  setReportDocumentName,
} = researchSlice.actions;

export default researchSlice.reducer;


